import { z } from "zod";

export const RoomTypeSchema = z.object({
  id: z.string().min(1, "Missing id"),
  name: z.string().trim().min(1, "Name required"),
  rooms: z.coerce.number().int().min(0, "Count can't be negative"),
  adrWeight: z.coerce
    .number()
    .int()
    .catch(100)
    .transform((n) => Math.min(300, Math.max(50, n))),
});

export const RoomMixSchema = z
  .array(RoomTypeSchema)
  .transform((list) => list.filter((r) => r.name.trim() !== "" || r.rooms > 0))
  .transform((list) =>
    list.map((r) => ({ ...r, id: r.id || crypto.randomUUID() })),
  );

export type RoomTypeParsed = z.infer<typeof RoomTypeSchema>;
